import { ChangePasswordRequestBody } from "@syla/shared/types/requests/ChangePasswordRequest";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function changePassword(
  props: ChangePasswordRequestBody,
): Promise<boolean> {
  try {
    const { data } = await axios.post<any, any, ChangePasswordRequestBody>(
      "/users/change-password",
      {
        currentPassword: props.currentPassword,
        newPassword: props.newPassword,
      },
    );
    return data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
